module.exports = __webpack_public_path__ + "img/2.193f404d.jpg";